export function defaultStateReducer(state = {}) {
  return state
}

export default function reducer(state = null) {
  return state
}
